import {Button, Card, CardBody, CardFooter, CardHeader, Typography,} from "@material-tailwind/react";
import {useEffect, useState} from "react";
import {getRoles} from "../../../services/user/role";
import {RoleGrid} from "./grid";
import {RoleForm} from "./form";
import {Paginator} from "../../system/paginator";


export function RoleManagement() {

  const [roles, setRoles] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  // const [gridRowCount, setGridRowCount] = useState(0);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [lastDataRefresh, setLastDataRefresh] = useState(null)

  useEffect(() => {
    async function getData() {
      const result = await getRoles();
      if (result.status === 200) {
        const {roles} = result.data;
        setRoles(roles);
      }
    }

    getData()
  }, [lastDataRefresh]);

  return (
    <div>
      <RoleForm role={gridSelectedRow} open={modalOpen} setOpen={setModalOpen} setLastDataRefresh={setLastDataRefresh}
                setGridSelectedRow={setGridSelectedRow}/>
      <Card className="h-full w-full">
        <CardHeader floated={false} shadow={false} className="rounded-none">
          <div className="mb-8 flex items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">نقش‌‌ها</Typography>
            <Button onClick={() => {
              setGridSelectedRow(null);
              setModalOpen(true);
            }} variant="outlined">جدید</Button>
          </div>
        </CardHeader>
        <CardBody className="overflow-scroll px-0">
          <RoleGrid roles={roles} setModalOpen={setModalOpen} setSelectedRow={setGridSelectedRow}/>
        </CardBody>
        <CardFooter className="flex items-center justify-center border-t border-blue-gray-50 p-4">
          <Paginator active={gridCurrentPage} setActive={setGridCurrentPage}/>
        </CardFooter>
      </Card>
    </div>
  );
}